import { Input } from "antd";
import ProgressCard, { ProgressCardProps } from "../ProgressCard";
import styles from "./style.module.scss";
import { useState, useMemo } from "react";
import SearchIcon from "assets/icons/SearchIcon";

export interface ProgressAndContentBarProps {
  items: ProgressCardProps[];
}

export default function ProgressCardList({
  items,
}: ProgressAndContentBarProps) {
  const [search, setSearch] = useState("");

  const filteredItems = useMemo(() => {
    if (!search.trim()) return items;
    return items.filter((item) =>
      item.label?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [items, search]);

  return (
    <>
      <Input
        prefix={<SearchIcon />}
        placeholder="Search Labels"
        color={"red"}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        allowClear
        rootClassName={styles.search}
      />

      <div className={styles.wrapper}>
        {/*  TODO: move to design system vl-6040 */}
        <div className={styles.headers}>
          <div>Classes</div>
          <div>Images for review</div>
        </div>
        {filteredItems.map((item, index) => (
          <ProgressCard
            key={index}
            label={item.label}
            maxItems={item.maxItems}
            itemLength={item.itemLength}
            active={item.active}
            onClick={item.onClick}
            id={item.id || index.toString()}
          />
        ))}
      </div>
    </>
  );
}
